/**
 * TanStack React Query 5 — single client for the whole app.
 *
 * Defaults:
 *   - 5 min staleTime so an identical lookup within the same session doesn't
 *     re-hit service-mail (the public tracking endpoint is rate-limited
 *     upstream — chatty UIs make that worse).
 *   - 5 min gcTime for cache warmth across navigations.
 *   - retry once for transient 5xx, never for 4xx (handled by the queryFn).
 */
import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000,
      gcTime: 5 * 60 * 1000,
      retry: 1,
      refetchOnWindowFocus: false,
    },
    mutations: {
      retry: 0,
    },
  },
});
